var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { compact } from "lodash";
import { AiLowerCaseIconGlyph } from "@shapeable/icons";
import { useEntityGptComponent } from "./use-entity-gpt-component";
export var useEntityContentTabs = function (entity) {
  var GptLayout = useEntityGptComponent();
  if (!entity) {
    return [];
  }
  var _a = entity.entityViews,
    entityViews = _a === void 0 ? [] : _a,
    _b = entity.entityType,
    entityType = _b === void 0 ? {} : _b;
  var useAi = entityType.useAi;
  // change this to main only.
  var tabViews = entityViews.filter(function (view) {
    var _a, _b;
    return ((_a = view.type) === null || _a === void 0 ? void 0 : _a.slug) === 'tab' || ((_b = view.type) === null || _b === void 0 ? void 0 : _b.slug) === 'main';
  });
  // build the content tabs spec
  var tabs = compact(__spreadArray([useAi && GptLayout && {
    id: 'ai',
    icon: React.createElement(AiLowerCaseIconGlyph, {
      size: 30
    })
  }], __read(tabViews.map(function (view, index) {
    // don't show a tab if we're showing a count and the count is zero (might need override for this, but will work most times)
    if (view.showCount && !view.count) {
      return null;
    }
    return {
      id: view.hash,
      isDefault: index === 0,
      label: view.label || view.name,
      count: view.showCount && view.count
      // todo add support for icons?
    };
  })), false));
  return tabs;
};